import * as React from 'react';
import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

import { Grid } from '@mui/material';

import VideoCard from './VideoCard';
import { VideoData } from './VideoData';
import { OpenVideoDialogEvent } from '../OpenVideoDialogEvent';

import './VideoPageStyles.css';

export interface IVideoGridProps {

}

const VideoGrid = (props: IVideoGridProps) => {
    const data = [
        {
            title: "Thumbstick Optimization 1",
            description: "Single Shooting Optimization - Thumbstick Stiffness 500",
            thumbnail: "./thumbnails/game_controller_optim_500.png",
            type: "video/mp4",
            src: "./videos/game_controller_optim_500.mp4",
        }, {
            title: "Thumbstick Optimization 2",
            description: "Single Shooting Optimization - Thumbstick Stiffness 3.000",
            thumbnail: "./thumbnails/game_controller_optim_3k.png",
            type: "video/mp4",
            src: "./videos/game_controller_optim_3k.mp4",
        }, {
            title: "Thumbstick Optimization 3",
            description: "Single Shooting Optimization - Thumbstick Stiffness 30.000",
            thumbnail: "./thumbnails/game_controller_optim_30k.png",
            type: "video/mp4",
            src: "./videos/game_controller_optim_30k.mp4",
        }, {
            title: "Scene View",
            description: "Controller simulation scene view camera",
            thumbnail: "./thumbnails/scene_complete_long.png",
            type: "video/mp4",
            src: "./videos/scene_complete_long.mp4",
        }, {
            title: "Car Camera",
            description: "3rd person car perspective",
            thumbnail: "./thumbnails/car_third_person2.png",
            type: "video/mp4",
            src: "./videos/car_third_person_long.mp4",
        }, {
            title: "Controls Movement ",
            description: "Bird's eye view of controller showcasing finger and button actions",
            thumbnail: "./thumbnails/controller_top.png",
            type: "video/mp4",
            src: "./videos/controller_top_long.mp4",
        }
    ]


    const [minTextHeight, setMinTextHeight] = useState<string>("0px");

    useEffect(() => {
        changeTextHeight();

        window.addEventListener("resize", () => changeTextHeight());

        return () => {
            window.removeEventListener("resize", () => {});
        };
    },[])

    const changeTextHeight = (newHeight?: string) => {
        const textHeight = newHeight ?? (`${document.getElementById("video-description-item-0")?.clientHeight}px` ?? "0px");
        setMinTextHeight(textHeight);
    }

    const handleVideoCardClick = (target: VideoData) => {
        window.dispatchEvent(new OpenVideoDialogEvent(target));
    }

    return (
        <div style={{position: "relative", top: "2vw", left: "2vw", height: "fit-content", width: "calc(100% - 4vw"}}>
            <Grid className="video-item-container" container columns={2} direction="row" justifyContent="center" spacing={6}>
                {data.map((video, index) => (
                    <Grid xs={1} item key={`video-page-video-${index}`}>
                        <motion.div id={`video-page-video-${index}`} whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.9 }} onClick={() => handleVideoCardClick(video)} style={{height: "fit-content"}} >
                            <VideoCard video={video} minHeight={minTextHeight} index={index} />
                        </motion.div>
                    </Grid>
                ))}
            </Grid>
        </div>
    )
}

export default VideoGrid;